import React from 'react';
import { Row } from 'reactstrap';
import Milestone from './Milestone';
import SupportTile from './SupportTile';

const Conversion = ({ conversion }) => {

    const { trial, final } = conversion;
    // TODO: revisit these two components to do a more rigorous optimization / refactor
    return (
        <Row className="d-flex flex-wrap justify-content-around unselectable">
            <SupportTile conversion={conversion} />
            <Milestone heading={'Trial'} milestone={trial} />
            <Milestone heading={'Final'} milestone={final} />
        </Row>
    );
};

export default Conversion;
